export default {
  trip_management: ['trip_management']
  // trip_add: ['trip_add'],
  // trip_edit: ['trip_edit'],
  // trip_status: ['trip_edit'],
  // trip_delete: ['trip_delete'],
  // trip_archive: ['trip_archive']
}
